import { useMemo } from 'react';
import { FieldOption } from '@aidkitorg/types/lib/admin-panel/filters';
import { ParentFieldEntry } from '@aidkitorg/types/lib/admin-panel/settings';
import { useSettings } from '../../../Contexts/SettingsContext';

/**
 * Hook that transforms fields from SettingsContext into FieldOption format
 * for use with FilterPanel components.
 *
 * This handles the common pattern of getting fields and formatting them
 * with proper labels and types.
 */
export const useSettingsFilterFields = (): FieldOption[] => {
  const { fields } = useSettings();

  return useMemo(() => {
    return fields.map(field => ({
      key: field.id,
      label: field.displayName || field.id.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      type: !field.parent ? ((field as ParentFieldEntry).dataType ?? 'text') : 'text'
    }));
  }, [fields]);
};
